import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import { blue } from "@mui/material/colors";
import RegularButton from "../../components/CustomButtons/Button";
import Snackbars from "../../components/Snackbar/Snackbar.js";
import { useTableDispenserUserConfig } from "./hooks"
import { DispenserUserSelectStation } from "./DispenserUserSelectStation";
import { DispenserUserSelectUnit } from "./DispenserUserSelectUnit";
import { useForm } from "../../hooks/useForm";
import { createNewDispenserUser } from "../../redux/actions/dispenserUser/dispenserUserAction";

const dispensersSelector = createSelector(
  (state) => state.dispenserUser.filter(dispenser => !dispenser?.dispenserUser?.id),
  (dispensers) => dispensers
);

export const FormDispenserUser = memo((props) => {
  const { handleClose } = props;
  const {
    setSnackBar, 
    clearSnackBar,
  } = useTableDispenserUserConfig();
  const { dispenserUserSelected, station, unit, snackBar } = useSelector(({ dispenserUser }) => dispenserUser);
  const dispenserOptions = useSelector(({ dispenserUser }) => dispensersSelector(dispenserUser));
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({ 
    username: '', 
    imei: '', 
    dispenser: null,
    driverUser: '' 
  });
  const { username, imei, dispenser, driverUser } = inputValues;
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if(!unit?.driverUser?.username) setSnackBar("La unidad no tiene usuario de chofer");
    else if (imei && imei.length < 20) setSnackBar("El IMEI debe de tener 20 caracteres");
    else if(username.length && station?.id && dispenser?.id) {
      const newValues = {
        username: username?.trim(),
        imei: imei ? imei?.trim() : null,
        idDispenser: dispenser.id,
        idDriverUser: unit?.driverUser?.id
      };

      dispatch(createNewDispenserUser(newValues));
      handleClose();
    } else setSnackBar("Campos con * son requeridos");
  }

  useEffect(() => {
    let newInputValues = {};
    if (dispenserUserSelected?.id) {
      const { dispenserUser } = dispenserUserSelected;

      newInputValues = {
        username: dispenserUser?.username === 'SIN ASIGNAR' ? '' : dispenserUser?.username,
        imei: dispenserUser?.imei === 'SIN ASIGNAR' ? '' : dispenserUser?.imei,
        dispenser: dispenserOptions.find(dispenser => dispenser.id === dispenserUserSelected.id)
      };
    }
    handleNewValues({
      ...inputValues,
      dispenser: null,
      ...newInputValues,
      driverUser: unit?.driverUser?.username ? unit?.driverUser?.username : '',
    });
    // eslint-disable-next-line 
  }, [dispenserUserSelected, unit?.driverUser?.username]);
  
  return (
    <>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20 }} onSubmit={handleSubmit}>
        <DispenserUserSelectStation size="medium" />
        <DispenserUserSelectUnit size="medium" />
        <TextField key={driverUser?.id} type="text" label="Usuario Chofer" name="driverUser" value={driverUser} disabled onChange={handleInputOnChange} variant="outlined" />
        <Autocomplete
          id="combo-box-demo"
          options={dispenserOptions}
          value={dispenser}
          filterSelectedOptions
          disabled={dispenserUserSelected?.id} 
          getOptionLabel={(option) => option.label ? option.label : option.name}
          renderInput={(params) => (
            <TextField
            {...params}
            name="type"
            label="Dispensador *"
            variant="outlined"
            disabled={dispenserUserSelected?.id} 
            />
          )}
          fullWidth
          onChange={(e, v) => handleNewValues({
            ...inputValues,
            dispenser: v
          })}
          noOptionsText="No se encuentran dispensadores"
        />
        <TextField type="text" label="Nombre de Usuario de Dispensador *" name="username" value={username} onChange={handleInputOnChange} variant="outlined" />
        <Box sx={{display: 'flex', flexDirection: 'column', marginTop: 30}}>
          <RegularButton 
            variant="contained" 
            color="facebook"
            style={{backgroundColor: blue[900], color: 'white'}} 
            onClick={handleSubmit}
          >
            Agregar
          </RegularButton>
          <RegularButton variant="contained" color="danger" onClick={handleClose}>Cancelar</RegularButton>
        </Box>
      </FormControl>
      <Snackbars
        place="tr"
        color='danger'
        message={snackBar.msg}
        open={snackBar.isOpen}
        closeNotification={clearSnackBar}
        close
      /> 
    </>
  );
});
